import { Component } from '@angular/core';
import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-bank-certificate-info',
  templateUrl: './bank-certificate-info.component.html',
  styleUrl: './bank-certificate-info.component.scss'
})
export class BankCertificateInfoComponent {
  faTwitter = faTwitter;
  faFacebook = faFacebook;
}
